import { get } from 'lodash';
import { RootState } from '../../store';

export const getIsAuthenticated = (state: RootState) =>
	get(state, 'routerContainer.isAuthenticated', true);

export const getTheme = (state: RootState) =>
	get(state, 'routerContainer.theme', 'light');
